module.exports = __webpack_public_path__ + "static/img/6.c678acd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/6.png
// module id = tTz4
// module chunks = 0